<template>
  <footer class="footer full-width">
    <p class="copyright">
      株式会社セブン-イレブン・ジャパン Copyright @SEVEN-ELEVEN JAPAN CO.,LTD.
      All Rights Reserved.
    </p>
  </footer>
</template>

<style scoped>
.footer {
  padding: 5px;
  font-size: 14px;
  color: #000000;
  background: #cccccc;
  border-top: 1px solid #e5e7eb;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  left: 0;
}
.full-width {
  width: 100vw;
  margin-left: calc(-50vw + 50%);
}
</style>
